import { render } from "./InsurancePage.vue?vue&type=template&id=36d16b7a&scoped=true"
import script from "./InsurancePage.vue?vue&type=script&lang=js"
export * from "./InsurancePage.vue?vue&type=script&lang=js"

import "./InsurancePage.vue?vue&type=style&index=0&id=36d16b7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36d16b7a"]])

export default __exports__